import ParticipantServiceFamily, {IParticipantServiceFamily} from "@/model/ServiceFamily/ParticipantServiceFamily"

export interface IEquipmentServiceFamily extends IParticipantServiceFamily {

}

class EquipmentServiceFamily extends ParticipantServiceFamily implements IEquipmentServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}

export default EquipmentServiceFamily